import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";
import NavsBurger from "./components/NavsBurger";

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockGallerySliderSimple from "./blocks/BlockGallerySliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockProjectDetailedSlider from "./blocks/BlockProjectDetailedSlider";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockScrollingText from "./blocks/BlockScrollingText";

import Share from "./components/Share";
import BlockAnchor from "./blocks/BlockAnchor";
import BlockIntroHome from "./blocks/BlockIntroHome";
import Footer from "./components/Footer";
import ArchiveProjectLab from "./page/ArchiveProjectLab";
import ArchiveProjectDetailed from "./page/ArchiveProjectDetailed";
import SingleProjectDetailed from "./page/SingleProjectDetailed";
import Page404 from "./page/Page404";

window.initMap = function(){
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Header.init();
	Footer.init();
	NavsFull.init();
	NavsBurger.init();

	// Blocks
	BlockAnchor.init();
	BlockBanner.init();
	BlockCollapse.init();
	BlockGallery.init();
	BlockGallerySlider.init();
	BlockGallerySliderSimple.init();
	BlockIntroHome.init();
	BlockMap.init();
	BlockMovie.init();
	BlockProjectDetailedSlider.init();
	BlockQuotes.init();
	BlockSlider.init();
	BlockScrollingText.init();
	BlockSliderScrollable.init();

	if (document.getElementsByClassName('post-type-archive-project_lab')[0]) {
		ArchiveProjectLab.init();
		console.log('ArchiveProjectLab initialized'); // Pour débugger
	}
	if (document.getElementsByClassName('post-type-archive-project_detailed')[0]) {
		ArchiveProjectDetailed.init();
		console.log('ArchiveProjectDetailed initialized'); // Pour débugger

	}
	
	if (document.getElementsByClassName('single-project_detailed')[0]) {
		new SingleProjectDetailed();
		console.log('SingleProjectDetailed initialized');
	}

	Page404.init();
	Share.init();
});
